import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "file-list-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_table_tab = _resolveComponent("table-tab");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_MyNeedAside = _resolveComponent("MyNeedAside");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: _ctx.activeTab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeTab = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "全部",
      name: "all"
    }, {
      default: _withCtx(() => [_ctx.activeTab == 'all' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "all"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "短信",
      name: "1"
    }, {
      default: _withCtx(() => [_ctx.activeTab == '1' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "1"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "宣传设计制作物料",
      name: "2"
    }, {
      default: _withCtx(() => [_ctx.activeTab == '2' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "2"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "成品物料",
      name: "3"
    }, {
      default: _withCtx(() => [_ctx.activeTab == '3' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "3"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "印刷品制作物料",
      name: "4"
    }, {
      default: _withCtx(() => [_ctx.activeTab == '4' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "4"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "电渠物料",
      name: "5"
    }, {
      default: _withCtx(() => [_ctx.activeTab == '5' ? (_openBlock(), _createBlock(_component_table_tab, {
        key: 0,
        onAsideRefresh: _ctx.asideRefresh,
        "active-tab": "5"
      }, null, 8, ["onAsideRefresh"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_MyNeedAside, {
    ref: "asideRef"
  }, null, 512)], 64);
}